import { FciValueTypes } from '../constants'

export const tableHeaders = ['File', 'Description', 'Date']

export const tableBodyData: Record<string, FciValueTypes> = {
  name: FciValueTypes.Text,
  description: FciValueTypes.Text,
  date: FciValueTypes.Date,
}
